"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=319%3A341))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:58.779Z
 */
export const AlarmClock = createSVGIcon(
  <>
    <path
      d="M2.60057 12.1999C2.60057 13.4475 2.8463 14.6828 3.32371 15.8354C3.80113 16.988 4.50089 18.0353 5.38304 18.9174C6.2652 19.7996 7.31246 20.4993 8.46505 20.9768C9.61764 21.4542 10.853 21.6999 12.1005 21.6999C13.3481 21.6999 14.5834 21.4542 15.736 20.9768C16.8886 20.4993 17.9359 19.7996 18.818 18.9174C19.7002 18.0353 20.3999 16.988 20.8773 15.8354C21.3548 14.6828 21.6005 13.4475 21.6005 12.1999C21.6005 10.9524 21.3548 9.71702 20.8773 8.56443C20.3999 7.41184 19.7002 6.36457 18.818 5.48242C17.9359 4.60026 16.8886 3.9005 15.736 3.42308C14.5834 2.94566 13.3481 2.69994 12.1005 2.69994C10.853 2.69994 9.61764 2.94566 8.46505 3.42308C7.31246 3.9005 6.2652 4.60026 5.38304 5.48242C4.50089 6.36457 3.80113 7.41184 3.32371 8.56443C2.8463 9.71702 2.60057 10.9524 2.60057 12.1999V12.1999Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.80075 23.4998L7.27913 20.5441"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.2 12.2997H7.99996"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.2001 6.69992V12.2999"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.99999 3.69997L5.99994 0.499997"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.6004 23.4999L17.122 20.5431"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.4003 3.69997L18.4003 0.499997"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "AlarmClock",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
